import type { MultiValue, SingleValue } from "react-select";

export interface continentCountries {
	label: string;
	options: {
		label: string;
		value: string;
		continent: string;
	}[];
}

export interface AdminManagementTableColumns {
	id: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	email: string;
	isActive: string;
	roles: string;
	roleId: string;
	photo: string;
}
export interface PoleManagementTableData {
	oldId?: number;
	poleId?: number;
	timezone?: number;
	location?: string;
	currentBattery?: number;
	assignedClub?: {
		id: number;
		name: string;
	}[];
	assignedClubCount?: number;
	serialNumber?: string;
	sync?: null;
	action?: null;
	id: string;
}

export interface PoleManagementTableColumns {
	column?: {
		action: string;
		assignedClub: String;
		assignedClubCount: string;
		currentBattery: string;
		id: string;
		location: string;
		sync: string;
		timezone: string;
	};
}
export interface AssignPoleData {
	assign_to?: string;
	club_id?: number;
	pole_id: number;
	role_id: number;
}

export interface CountryExpansionTableColumns {
	countryCode?: string;
	countryName?: string;
	enabled?: boolean | string;
	femaleEnabled?: string | boolean;
	maleEnabled?: string | boolean;
	id?: number;
	tooltip?: string;
	tooltipFemale?: string;
	continent?: string;
}
export interface CountryExpansionTableColumnsData {
	countries?: { label?: string; value?: string }[];
	enabled?: string | boolean;
	femaleEnabled?: string | boolean;
	maleEnabled?: string | boolean;
	id?: number | null;
	tooltip?: string;
}

export enum GameOptions {
	AI = "ai",
	STATISTICS_RATING = "statistics_rating",
	STATISTICS_PLAYERS = "statistics_players",
	STATISTICS_TEAMS = "statistics_teams",
	EVENTS = "events",
	DOWNLOADABLE = "downloadable",
	CLIPS = "clips",
	DOWNLOADABLE_GAMETAGS = "downloadable_gametags",
	PLAYER_STATS_SEARCH = "player_stats_search",
	PHYSICAL_METRICS = "physical_metrics",
	CLIPS_ACROSS_GAMES = "clips_across_games",
}
export interface NonPartnerClubData {
	id: number;
	name: string;
	country: string | null;
	logo: string | null;
	description: string | null;
	contactName: string | null;
	contactPhoneNumber: number | null;
	contactEmail: string | null;
	city: string | null;
	zipcode: number | null;
	address: string | null;
	region: string | null;
	geographicalArea: string | null;
	showCase: boolean | null;
	gamesCount: number;
	playersCount: number;
	clubExternalLinks: SingleValue<{
		link: string;
		type: string;
	}>;
}
export interface NonPartnerPlayerData {
	clubNonpartnerId: number;
	firstName: string;
	id: number | null;
	lastName: string;
	playedInNationalTeam: boolean;
	npClubCountry: string;
	npClubLogo: null | string;
	npClubName: string;
	picture: null | string;
	birthday: string;
	position: string;
	nationality: string;
	nationality2: string;
	strongestFoot: string;
	playersCount?: number;
	gamesCount?: number;
	tranLink?: string;
	federationLink?: string;
	height?: number | null;
	weight?: number | null;
	teamId?: number;
	teamName?: string;
	position2?: string;
	photo?: string;
	notes?: string;
	gender?: string | null;
}

export interface nonPartnerClubAndPlayerData {
	clubNonpartnerId?: number;
	firstName?: string;
	id?: number;
	lastName?: string;
	playedInNationalTeam?: boolean;
	npClubCountry?: string;
	npClubLogo?: null | string;
	npClubName?: string;
	picture?: null | string;
	birthday?: string;
	position?: string;
	nationality?: string;
	strongestFoot?: string;
	name?: string;
	country?: string | null;
	logo?: string | null;
	description?: string | null;
	contactName?: string | null;
	contactPhoneNumber?: number | null;
	contactEmail?: string | null;
	city?: string | null;
	zipcode?: number | null;
	address?: string | null;
	region?: string | null;
	geographicalArea?: string | null;
	showCase?: boolean | null;
	gamesCount?: number;
	playersCount?: number;
}

export interface ClubData {
	address?: null;
	city?: null;
	contactEmail?: null;
	contactName?: null;
	contactPhoneNumber?: null;
	country?: string;
	description?: null;
	gamesCount?: number;
	geographicalArea?: null;
	id: string;
	logo?: null;
	name?: string;
	playersCount?: number;
	region?: null;
	showCase?: null;
	zipcode?: null;
}

export interface PlayerData {
	birthday?: null;
	clubNonpartnerId?: string;
	firstName?: string;
	id?: number;
	lastName?: string;
	nationality?: null;
	npClubCountry?: string;
	npClubLogo?: null;
	npClubName?: string;
	picture?: null;
	position?: null;
	strongestFoot?: null;
	clubId?: number;
}
export interface NonPartnerMigrationPlayer {
	club: string;
	clubCountry: null | string;
	teamCategory: null | string;
	teamName: null | string;
	firstName: string;
	id: number;
	lastName: string;
	picture: string;
	percentage: number;
	migrationId: number;
	targetPlayerId: number;
	status: string;
	selected: boolean;
	selectedTeam: SingleValue<{
		value: string;
		label: string;
	}>;
	mergeError: null | string;
	gender: string | null;
}
export enum MigrationType {
	PARTNER = "partner",
	NON_PARTNER = "non-partner",
	ANY = "any",
}

export enum ClubMigrationType {
	PARTNER = "partner",
	NON_PARTNER = "nonpartner",
}

export interface MigrationStatusPlayersTable {
	firstName: string;
	lastName: string;
	team: string;
	status: string;
}
export interface MigrationStatusGamesTable {
	id: string;
	category: string;
	homeTeam: { label: string; value: number | null };
	homeClub: string;
	awayTeam: { label: string; value: number | null };
	awayClub: string;
	date: string;
	migratedClub?: string;
}
export interface MigrationStatusData {
	failed: {
		skippedPlayers: MigrationStatusPlayersTable[];
		skippedPlayersCount: number;
		skippedGames: any[];
		skippedGamesCount: number;
	};
	success: {
		migratedPlayers: MigrationStatusPlayersTable[];
		migratedPlayersCount: number;
		migratedGames: any[];
		migratedGamesCount: number;
	};
}

export interface NotificationManagementTableColumns {
	date?: string;
	email?: string;
	failed?: number;
	id?: number;
	title?: string;
	authorName?: string;
	language?: string;
	methods?: string;
	phoneNumber?: number;
	successful?: number;
	status?: string;
	userCount?: number;
	retry?: string;
	detail?: string;
	percentage?: number;
	refresh?: string;
	messages?: string;
	authorId?: number;
}
export interface NotificationManagementData {
	authorName?: string;
	date?: string;
	failed?: number;
	id?: number;
	messages?: { fullLanguage?: string; language?: string; title?: string; body?: string }[];
	methods?: string[];
	percentage?: number;
	receivers?: {
		users?: MultiValue<{ value?: number | undefined; label?: string | undefined }> | null | [];
		amateurClubs?: MultiValue<{ value?: number | undefined; label?: string | undefined }> | null | [];
		proClubs?: MultiValue<{ value?: number | undefined; label?: string | undefined }> | null | [];
	};
	authorId?: number;
	title?: string;
	successful?: number;
	userCount?: number;
}

export interface JobDetailTableColumns {
	id?: number;
	email?: string;
	method?: string;
	locale?: string;
	sentDateTime?: string;
	delivered?: boolean;
	exception?: string;
	firstName?: string;
	lastName?: string;
	phoneNumber?: string;
}

export enum TableColumns {
	LAST_NAME = "lastName",
	EXCEPTION = "exception",
	PHONE_NUMBER = "phoneNumber",
	SMS = "SMS",
	EMAIL = "Email",
}

export enum Continents {
	SOUTH_AMERICA = "southAmerica",
	NORTH_AMERICA = "northAmerica",
	OCEANIA = "oceania",
	EUROPE = "europe",
	ASIA = "asia",
	AFRICA = "africa",
}

/** Subscription product display values; aligned with backend SubscriptionProduct enum. */
export enum SubscriptionProduct {
	BRONZE = "Bronze",
	SILVER = "Silver",
	GOLD = "Gold",
	PLATINUM = "Platinum",
	NEWSFEED = "Newsfeed",
	CUSTOMER_API = "Customer API",
	EYEBALL_ADDONS = "Eyeball Add-ons",
}


export enum Status {
	NOT_AVAILABLE = "N/A",
}

export enum ClubType {
	PARTNER = "partner",
	NON_PARTNER = "nonpartner",
}

export enum Resource {
	PRODUCT_MANAGEMENT = "product_management",
	CLUBS_AMATEUR = "clubs_amateur",
	GAME_UPLOADS = "game_uploads",
	GAME_UPLOAD_SINGLE = "game_upload_single",
	CLUBS_PRO = "clubs_pro",
	OPERATIONS_MANAGEMENT = "operations_management",
	SUBSCRIPTION_DEAL_ID = "subscription_deal_id",
	NON_PARTNER_CLUB = "non_partner_club",
}

export enum Permission {
	READ = "read",
	LIST = "list",
	CREATE = "create",
	EDIT = "edit",
	DELETE = "delete",
	GAME_VIP = "game_vip",
	GAME_HIDDEN = "game_hidden",
	GAME_SCORE = "game_score",
	GAME_ASSIGNEE_SELECTION = "game_assignee_selection",
	GAME_VIEW_SLA = "game_view_sla",
	GAME_STATUS_EDIT = "game_status_edit",
	GAME_ANALYZE = "game_analyze",
	GAME_CREATE_GAME = "game_create_game",
}
